export default __webpack_public_path__ + "static/media/icon-bank2.2d56840a.svg";